function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
!function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : t.dayjs_plugin_customParseFormat = e();
}(this, function () {
  "use strict";

  var t,
    e = {
      LTS: "h:mm:ss A",
      LT: "h:mm A",
      L: "MM/DD/YYYY",
      LL: "MMMM D, YYYY",
      LLL: "MMMM D, YYYY h:mm A",
      LLLL: "dddd, MMMM D, YYYY h:mm A"
    },
    n = function n(t, _n) {
      return t.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function (t, r, o) {
        var i = o && o.toUpperCase();
        return r || _n[o] || e[o] || _n[i].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function (t, e, n) {
          return e || n.slice(1);
        });
      });
    },
    r = /(\[[^[]*\])|([-:/.()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g,
    o = /\d\d/,
    i = /\d\d?/,
    s = /\d*[^\s\d-:/()]+/;
  var a = function a(t) {
      return function (e) {
        this[t] = +e;
      };
    },
    f = [/[+-]\d\d:?\d\d/, function (t) {
      var e, n;
      (this.zone || (this.zone = {})).offset = (e = t.match(/([+-]|\d\d)/g), 0 === (n = 60 * e[1] + +e[2]) ? 0 : "+" === e[0] ? -n : n);
    }],
    h = function h(e) {
      var n = t[e];
      return n && (n.indexOf ? n : n.s.concat(n.f));
    },
    d = function d(e, n) {
      var r,
        o = t.meridiem;
      if (o) {
        for (var i = 1; i <= 24; i += 1) {
          if (e.indexOf(o(i, 0, n)) > -1) {
            r = i > 12;
            break;
          }
        }
      } else r = e === (n ? "pm" : "PM");
      return r;
    },
    u = {
      A: [s, function (t) {
        this.afternoon = d(t, !1);
      }],
      a: [s, function (t) {
        this.afternoon = d(t, !0);
      }],
      S: [/\d/, function (t) {
        this.milliseconds = 100 * +t;
      }],
      SS: [o, function (t) {
        this.milliseconds = 10 * +t;
      }],
      SSS: [/\d{3}/, function (t) {
        this.milliseconds = +t;
      }],
      s: [i, a("seconds")],
      ss: [i, a("seconds")],
      m: [i, a("minutes")],
      mm: [i, a("minutes")],
      H: [i, a("hours")],
      h: [i, a("hours")],
      HH: [i, a("hours")],
      hh: [i, a("hours")],
      D: [i, a("day")],
      DD: [o, a("day")],
      Do: [s, function (e) {
        var n = t.ordinal,
          r = e.match(/\d+/);
        if (this.day = r[0], n) for (var o = 1; o <= 31; o += 1) {
          n(o).replace(/\[|\]/g, "") === e && (this.day = o);
        }
      }],
      M: [i, a("month")],
      MM: [o, a("month")],
      MMM: [s, function (t) {
        var e = h("months"),
          n = (h("monthsShort") || e.map(function (t) {
            return t.substr(0, 3);
          })).indexOf(t) + 1;
        if (n < 1) throw new Error();
        this.month = n % 12 || n;
      }],
      MMMM: [s, function (t) {
        var e = h("months").indexOf(t) + 1;
        if (e < 1) throw new Error();
        this.month = e % 12 || e;
      }],
      Y: [/[+-]?\d+/, a("year")],
      YY: [o, function (t) {
        t = +t, this.year = t + (t > 68 ? 1900 : 2e3);
      }],
      YYYY: [/\d{4}/, a("year")],
      Z: f,
      ZZ: f
    };
  var c = function c(e, o, i) {
    try {
      var s = function (e) {
          for (var o = (e = n(e, t && t.formats)).match(r), i = o.length, s = 0; s < i; s += 1) {
            var a = o[s],
              f = u[a],
              h = f && f[0],
              d = f && f[1];
            o[s] = d ? {
              regex: h,
              parser: d
            } : a.replace(/^\[|\]$/g, "");
          }
          return function (t) {
            for (var e = {}, n = 0, r = 0; n < i; n += 1) {
              var s = o[n];
              if ("string" == typeof s) r += s.length;else {
                var a = s.regex,
                  f = s.parser,
                  h = t.substr(r),
                  d = a.exec(h)[0];
                f.call(e, d), t = t.replace(d, "");
              }
            }
            return function (t) {
              var e = t.afternoon;
              if (void 0 !== e) {
                var n = t.hours;
                e ? n < 12 && (t.hours += 12) : 12 === n && (t.hours = 0), delete t.afternoon;
              }
            }(e), e;
          };
        }(o)(e),
        a = s.year,
        f = s.month,
        h = s.day,
        d = s.hours,
        c = s.minutes,
        m = s.seconds,
        l = s.milliseconds,
        M = s.zone,
        Y = new Date(),
        v = h || (a || f ? 1 : Y.getDate()),
        p = a || Y.getFullYear(),
        D = 0;
      a && !f || (D = f > 0 ? f - 1 : Y.getMonth());
      var y = d || 0,
        L = c || 0,
        g = m || 0,
        $ = l || 0;
      return M ? new Date(Date.UTC(p, D, v, y, L, g, $ + 60 * M.offset * 1e3)) : i ? new Date(Date.UTC(p, D, v, y, L, g, $)) : new Date(p, D, v, y, L, g, $);
    } catch (t) {
      return new Date("");
    }
  };
  return function (e, n, r) {
    r.p.customParseFormat = !0;
    var o = n.prototype,
      i = o.parse;
    o.parse = function (e) {
      var n = e.date,
        o = e.utc,
        s = e.args;
      this.$u = o;
      var a = s[1];
      if ("string" == typeof a) {
        var f = !0 === s[2],
          h = !0 === s[3],
          d = f || h,
          u = s[2];
        h && (u = s[2]), f || (t = u ? r.Ls[u] : this.$locale()), this.$d = c(n, a, o), this.init(), u && !0 !== u && (this.$L = this.locale(u).$L), d && n !== this.format(a) && (this.$d = new Date("")), t = void 0;
      } else if (a instanceof Array) for (var m = a.length, l = 1; l <= m; l += 1) {
        s[1] = a[l - 1];
        var M = r.apply(this, s);
        if (M.isValid()) {
          this.$d = M.$d, this.$L = M.$L, this.init();
          break;
        }
        l === m && (this.$d = new Date(""));
      } else i.call(this, e);
    };
  };
});